import React from 'react';
import { STATISTIC } from '../Pages';

export default {
  path: STATISTIC.pageURL,
  async action() {
    const { default: StatisticTabs } = await import('./StatisticTabs');
    return (
      <StatisticTabs
        key={'statisticTabs'}
        unavailable={window.__APP_CONFIG__.DISABLE_STATISTICS}
      />
    );
  },
};
